import {
  Inject,
  Injectable,
  Optional,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SettingsModel } from '../models/settings.module';
import { AppService } from './app.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  public settings = signal<SettingsModel>(new SettingsModel());

  isMobile = signal<boolean>(false);
  isTablet = signal<boolean>(false);

  private serverMobile = false;
  private serverTablet = false;

  constructor(
    private appService: AppService,
    @Optional() @Inject('ISMOBILE') protected mobile: boolean,
    @Optional() @Inject('ISTABLET') protected tablet: boolean,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    this.serverMobile = mobile;
    this.serverTablet = tablet;
  }

  setMobile(value: boolean) {
    this.isMobile.set(value);
  }

  getSettings() {
    this.appService.getData('settings').then((x) => {
      this.settings.set(JSON.parse(x));
    });
  }

  updateSettingsData(input: SettingsModel) {
    this.settings.set(input);
  }

  getMobileStatus() {
    if (isPlatformServer(this.platformId)) {
      return this.isMobile();
    }

    if (isPlatformBrowser(this.platformId)) {
      const ua = navigator.userAgent;

      if (
        /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
          ua.toString(),
        )
      ) {
        return true;
      }
    }

    return false;
  }

  getTabletStatus() {
    if (isPlatformServer(this.platformId)) {
      return this.serverTablet;
    }
    const ua = navigator.userAgent;

    if (ua.match(/Tablet|iPad|iPod/i)) {
      return true;
    }

    return false;
  }

  getImageType(url: string) {
    const isImage = url.match(/.(jpg|jpeg|png|webp|gif)$/i);
    if (isImage) {
      return true;
    }

    return false;
  }

  getVideoType(url: string) {
    url = url.toLowerCase();
    // 'mp4', 'mov', 'wmv', 'flv', 'avi', 'avchd', 'webm', 'mkv'
    if (url.includes('.mp4')) {
      return 'video/mp4';
    }

    if (url.includes('.mov')) {
      return 'video/mov';
    }

    if (url.includes('.wmv')) {
      return 'video/wmv';
    }

    if (url.includes('.flv')) {
      return 'video/flv';
    }

    if (url.includes('.avi')) {
      return 'video/avi';
    }

    if (url.includes('.avchd')) {
      return 'video/avchd';
    }

    if (url.includes('.webm')) {
      return 'video/webm';
    }

    return 'video/mkv';
  }
}
